import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { MultipleDoFileOption } from 'src/app/core/models/transport-operation/multiple-do-file-option';
import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../transport-operation/services/delivery-order.service';
import { combineLatest, map, of } from 'rxjs';
import { CodeConverter } from 'server/entity/code-converter';

@Component({
  selector: 'laas-multiple-dofile-management',
  templateUrl: './multiple-dofile-management.component.html',
  styleUrl: './multiple-dofile-management.component.scss'
})
export class MultipleDofileManagementComponent
  extends SessionBaseComponent
  implements OnInit, OnChanges
{

  @ViewChildren('fileUpload') fileUploads!: QueryList<FileUpload>;
  @Input() doFileList!: { doNo: string, fileType: string }[];
  @Input() display!: boolean;
  @Output() onClose = new EventEmitter<boolean>();

  doFileOptionsList: MultipleDoFileOption[] = [];

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private commonDataService: CommonDataService,
    private shippingDocumentService: ShippingDocumentService
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.display) {
      return;
    }

    const keysOfChanges = Object.keys(changes);
    if (!keysOfChanges.includes('doFileList')) {
      return;
    }

    this.getAllDocOptions();
  }

  getAllDocOptions(): void {
    this.doFileOptionsList = [];
    for(const doFile of this.doFileList) {
      const fileType = doFile.fileType ?? 'DeliveryOrder';
      const option: MultipleDoFileOption = {
        doNo: doFile.doNo,
        fileType,
        documentOptions: [],
        selectedDocument: '',
        docs: [],
        isLoading: false,
        selectedDoc: {},
        title: '',
        downloadMergeFileParams: new DownloadMergeFileRequset(),
      };
      this.doFileOptionsList.push(option);
      const obsvOfOption = ["Warehousing", "HawbNo"].includes(fileType) ?
        this.commonDataService.getCodeConverter(
          this.laasSetting.language,
          'DropdownList',
          'warehousingDoc'
        ).pipe(
          map((options: CodeConverter[]) => {
            return options.map((x) => ({
              text: x.codeDesc,
              value: x.codeKey,
            }));
          })
        ) :
        this.shippingDocumentService.getDocumentOptions(
          this.laasSetting.language,
          doFile.doNo,
          fileType
        );
      combineLatest([
        obsvOfOption,
        this.translateService.get('Common.DropDown.Select')
      ]).subscribe({
        next: ([options, selectStr]: [any[], string]) => {
          option.documentOptions = [
            { text: selectStr, value: '' },
            ...options
          ];
          this.searchDocumentsByDoNoAndFileType(option);
        },
      });
    }
  }

  searchDocumentsByDoNoAndFileType(doFileOption: MultipleDoFileOption): void {
    if (!doFileOption) { return; }
    const { doNo, fileType } = doFileOption;
    doFileOption.isLoading = true;
    const docTypes = [...doFileOption.documentOptions.map((x) => x.value)];
    const searchObj = {
      docReference: [
        {
          key: doNo,
          name: fileType,
        },
      ],
      docType: docTypes,
    };
    this.getAllDialogTitle(doFileOption);
    this.shippingDocumentService.getDocs(searchObj).subscribe({
      next: (result) => {
        doFileOption.docs = result.body;
      },
      complete: () => {
        doFileOption.isLoading = false;
      },
    });
  }

  hideDialog(event: any): void {
    this.onClose.emit(this.display);
  }

  downloadChange(event: any, rowData: { docId: string, version: string, docType: string, fileType: string, referenceKey: string }): void {
    const { docId: sn, version, docType, fileType, referenceKey } = rowData;
    this.loader.show();
    const downloadMergeFileRequset = new DownloadMergeFileRequset();
    downloadMergeFileRequset.docTypes = docType.split(',');
    downloadMergeFileRequset.referenceKeys = referenceKey.split(',');
    this.shippingDocumentService.downloadMergeFile(downloadMergeFileRequset).pipe(
      map(({ file, isMutipleFile, fileName }: { file: string, isMutipleFile: string, fileName: string }) => {
        const byteStr = atob(file);
        const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
        const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteStr.length; i++) {
          int8Array[i] = byteStr.charCodeAt(i);
        }

        return {
          file: int8Array,
          isMutipleFile,
          fileName,
        }
      })
    ).subscribe({
      next: ({ file, isMutipleFile, fileName }) => {
        const chkMultipleFile = isMutipleFile == 'MULTIPLE';
        const blobOptions = {
          type: chkMultipleFile ? 'application/zip' : 'application/octet-stream',
        }
        const downloadName = fileName;
        const data = new Blob([file], blobOptions);
        const url = URL.createObjectURL(data);
        const linkEle = document.createElement('a');
        linkEle.download = downloadName;
        linkEle.href = url;
        linkEle.click();
        URL.revokeObjectURL(url);
        linkEle.remove();
      },
      complete: () => {
        this.loader.hide();
      },
    });
  }

  deleteFileBtn(event: any, deleteObj: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: '確定要刪除嗎?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteFile(event, deleteObj);
      },
      reject: () => {
        //reject action
      },
    });
  }

  deleteFile(event: any, deleteObj: any): void {
    const obsvOfDelete = deleteObj.docId ?
      this.shippingDocumentService.deleteFileBySnCode(deleteObj.docId) :
      this.shippingDocumentService.deleteFile(deleteObj.seqNo);
    obsvOfDelete.subscribe({
      next: (result) => {
        this.toastService.success(
          this.translateService.instant(
            'BoookingSearch.Success.DeleteSuccess'
          ),
          false
        );
        this.getAllDocOptions();
      },
      error: (result) => {
        this.toastService.error(
          this.translateService.instant('BoookingSearch.Error.DeleteFail')
        );
      },
      complete: () => {
        this.loader.hide();
      },
    });
  }

  fileUploader(event: any, item: MultipleDoFileOption, index: number): void {
    this.loader.show();
    const fileUpload = this.fileUploads.toArray()[index];

    if (item.selectedDocument === '') {
      this.toastService.warn(
        this.translateService.instant('BoookingSearch.Alert.FileType'),
        false
      );
      this.loader.hide();
      return;
    }

    const uploadObj = {
      docType: item.selectedDocument,
      docReference: {
        name: item.fileType,
        key: item.doNo,
      },
      operatorName: this.userProfile.userName,
      remark: item.doNo,
    };

    this.shippingDocumentService
      .uploadFile(event.files[0], uploadObj)
      .subscribe({
        next: (rsp) => {
          if (rsp.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round((100 * rsp.loaded) / rsp.total);
            fileUpload.progress = percentDone;
          }
          if (rsp.type === HttpEventType.Response) {
            if (rsp.status == 200) {
              this.toastService.success(
                this.translateService.instant(
                  'BoookingSearch.Success.Uploadsuccess'
                ),
                false
              );
              this.getAllDocOptions();
            }
          }
        },
        error: (rsp) => {
          let invalidFileType = rsp.error.errorMsg;
          let errorCode = rsp.error.errorCode;
          let category = rsp.error.category;
          this.commonDataService.getErrorCodes(this.laasSetting.language, category).subscribe({
          next: (errorList) => {
            let matchedError = errorList.find((error: any) => error.errorCode == errorCode)
            this.toastService.error(matchedError.errorMsg + invalidFileType);
          }
        })
          this.loader.hide();
        },
        complete: () => {
          item.selectedDocument = '';
          fileUpload.progress = 0;
          fileUpload.clear();
          this.loader.hide();
        },
      });
  }

  getAllDialogTitle(doFileOption: MultipleDoFileOption): void {
    if (!doFileOption) return;
    const fileType = doFileOption.fileType;
    combineLatest([
      this.translateService.get('DOQuery.Form.FileUpload.DO'),
      of('Booking'),
      this.translateService.get('ReceiptFormUpload.ReceiptNum'),
      this.translateService.get('WarehousingAbnormal.Form.HawbNo'),
    ]).subscribe({
      next: (result) => {
        if (fileType == 'Booking') {
          doFileOption.title = result[1];
          return;
        }
        if (fileType == 'Warehousing') {
          doFileOption.title = result[2];
          return;
        }
        if (fileType == 'HawbNo') {
          doFileOption.title = result[3];
          return;
        }
        doFileOption.title = result[0];
      },
    });
  }
}
